import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
/**
 * Recaptcha - рендерит recaptcha от гугла на элемент с аттрибутом recaptcha
 * настройки рекапчи беруться из свойств данного элемента
 */
export class RecaptchaBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('recaptcha');
    }

    protected installBehaviour(element: HTMLElement): void {
        const recaptcha: any = Utils.getObjectByAttributes(
            this.tag,
            element,
            null,
            {}
        );
        grecaptcha.render(recaptcha.selector, {
            sitekey: recaptcha.publickey,
            callback: (code) => {
                this.setRecaptchaValueAndRevalidate(
                    recaptcha.resultselector,
                    code
                );
                if (recaptcha.callback) {
                    Utils.runFunctionByName(recaptcha.callback, null, null);
                }
            },
            'expired-callback': () => {
                this.setRecaptchaValueAndRevalidate(
                    recaptcha.resultselector,
                    null
                );
            },
        });
    }

    private setRecaptchaValueAndRevalidate(selector, code) {
        const input: any = $(selector)[0];
        $(input).val(code);

        const form = input.form;
        const validator = (<any>$(form)).validate();
        validator.element(input);
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.RecaptchaBehaviour = RecaptchaBehaviour;